module.exports = __webpack_public_path__ + "static/media/flower-icon.bf04b4ea.svg";